module.exports = __webpack_public_path__ + "img/signup_icon.7a087557.svg";